module.exports = __webpack_public_path__ + "img/2.afd80d6f.png";